import {find} from '../helpers';

// const element = find('[data-video-stream]');
// const video = find('[data-video]');
const videoBg = find('[data-video-bg]');

// if (element) {
//     import('./index');
// }
//
// if (video) {
//     import('./video');
// }

if (videoBg) {
    import('./hero');
}
